import React, { useState, useEffect, useRef } from 'react';
import useDataStore from "../data/store/useDataStore";
import { styled } from "styled-components";
import CaseIcon from '../assets/icon/case_black.svg';
import arrowIcon from '../assets/arrow_grey.svg';
import arrowWhiteIcon from '../assets/arrow_white.svg';
import clipIcon from '../assets/icon/clip.svg';
import Fieldset from "../ui/fieldset/fieldset";
import Question from "../ui/form/question";
import Button from "../ui/button/button";
import AnswerText from "../ui/messages/answerText";
import { Navbar, Nav } from 'react-bootstrap';
import useUserStore from "../data/store/useUserStore";
import apiService from "../data/service/apiService";
import { useNavigate, useLocation } from "react-router";
import Popup from "../ui/popup/popup";
import Flex from "../ui/flex/flex";
import QuestionText from "../ui/messages/questionText";
import Attachment from "../ui/messages/attachment";
import { t } from 'ttag';

const CasePage = styled.div`
  display: flex;
  height: 100vh;
  
  .menu {
    width: 300px;
    height: 100%;
    
    padding-left: 8px;
    
    border: 1px solid #F5F5F5;
    background: #FFF;
    box-shadow: 0px 13.55124px 18.06832px 0px rgba(50, 32, 64, 0.05), 0px 36.13665px 36.13665px 0px rgba(29, 0, 91, 0.10), 0px -1.80683px 3.61366px 0px rgba(36, 0, 81, 0.00), 3px 0px 8px 0px rgba(0, 11, 50, 0.08);
    
    .logo {
      height: 53px;
      margin-top: 5px;
      margin-bottom: 10px;
    }
    
    .navbar {
      flex-direction: column;
      background-color: #FFF !important;

      #basic-navbar-nav {
        width: 100%;
        padding: 0px;
        margin: 0px;
        margin-right: 8px;
        
        .navbarSection {
          overflow-x: hidden;
          overflow-y: auto;
          height: 400px;
          position: relative;
          width: 100%;
        }
        
        .navbar-nav {
          display: block;
          margin-bottom: 8px;
          width: 100%;
          .nav-link {
            border: 1px solid red;

            height: 35px;
            width: 100%;
            border-radius: 8px;
            border: 0px solid;
            text-align: left;
            background-color: #FFF;
            
            color: #6F6F6F;
            font-variant-numeric: lining-nums proportional-nums;
            font-family: Raleway;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 150%;
            
            padding: 0px;
            margin-bottom: 10px;
            
            .label {
              display: block;
              float: right;
              margin-right: 30px;
              border-radius: 4px;
              background: #F7326D;
              padding: 5px 10px;
              margin-top: 3px;
              
              color: #FFF;
              font-variant-numeric: lining-nums proportional-nums;
              font-family: Raleway;
              font-size: 14px;
              font-style: normal;
              font-weight: 700;
              line-height: normal;
              letter-spacing: 1.4px;
              text-transform: uppercase;
            }
            
            .icon {
              width: 36px;
              height: 35px;
              background-color: #F5F5F5;
              margin-right: 10px;
              border-radius: 8px;
              padding: 7px;
            }
            
            &::after {
              position: absolute;
              content: '';
              height: 35px;
              width: 35px;
              right: -10px;
              margin-top: 10px;
              background-image: url(${arrowIcon});
              background-repeat: no-repeat;
            }
            
            &:hover {
              background-color: #F5F5F5;
            }
          }
          .nav-link.active {
            background-color: #9738FF;
            color: #FFF;
            .icon {
              background-color: unset;
            }
            &::after {
              background-image: url(${arrowWhiteIcon}) !important;
            }
          }
        }
      }
      a {
        width: 100%;
      }
      h3 {
        width: 100%;
        color: #6F6F6F;
        font-variant-numeric: lining-nums proportional-nums;
        font-family: Raleway;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 150%;
        text-transform: uppercase;
      }
      .mr-auto {
        h3 {
          display: none;
        }
      }
    }
  }
  .content {
    flex: 1;
    border: 1px solid #F5F5F5;
    background: #FFF;
    box-shadow: 0px 13.55124px 18.06832px 0px rgba(50, 32, 64, 0.05), 0px 36.13665px 36.13665px 0px rgba(29, 0, 91, 0.10), 0px -1.80683px 3.61366px 0px rgba(36, 0, 81, 0.00), 3px 0px 8px 0px rgba(0, 11, 50, 0.08);
    margin: 20px 20px 20px 64px;
    padding: 46px;
    border-radius: 20px;
    
    .caseHeader {
      display: flex;
      justify-content: space-between;
      
      h1 {
        flex: 1;
        text-align: left;
      }
      
      button {
        text-align: right;
        background-color: #F3ECFF;
        color: #9738FF;
        margin-left: 5px;
        margin-right: 5px;
      }
    }
    
    h1 {
      font-family: Recoleta;
      font-size: 36px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      text-transform: capitalize;
    }
    
    .scrollSection {
      overflow-y: scroll;
      overflow-x: hidden;
      height: 400px;
      padding-right: 30px;
    }
    
    .form {
      display: flex;
      justify-content: center;
      
      .uploadFile {
        border: 0px;
        border-radius: 10px;
        background: #F5F5F5;
        margin-right: 11px;
      }
      
      .sendMsg {
        margin-left: 11px;
      }
      
      .message {
        border-radius: 5px;
        background: #F5F5F5;
        padding-left: 10px;
        
        font-variant-numeric: lining-nums proportional-nums;
        font-family: Raleway;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%; /* 18px */
        
        border: 0px;
        width: 50%;
      }
    }
  }
  
  @media (max-width: 991px) {
    .menu {
      z-index: 1;
      width: 100%;
      height: unset;
      position: fixed;
      
      .navbar {
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;

        h3 {
          display: none;
        }
        
        .navbar-nav {
          height: 100vh;
        }
        
        button {
          margin-right: 20px;
          position: absolute;
          right: 0px;
          top: 28px;
        }
        
        .mr-auto {
          padding-left: 10px;
          h3 {
            display: block !important;
          }
        }
      }
    }
    .content {
      margin: 0px;
      padding: 120px 0px 20px 20px;
      border-radius: 0px;
      min-width: 360px;
      
      .caseHeader {
        display: block;
        button {
          margin-right: 20px;
        }
        .scrollToTheTop {
          font-size: 14px;
        }
        h1 {
          font-size: 22px !important;
        }
      }
    }
  }
`;

const HiddenInput = styled.input`
  display: none;
`;

const buildQuestionsWithAnswers = (answers, list) => {
  const out = [];
  if (!answers?.length) {
    return out;
  }
  for (const answer of answers) {
    const qFromForm = list?.find(i => i.id == answer.id);
    const q = qFromForm
      ? { ...qFromForm }
      : {
          id: answer.id,
          text: answer.text,
          type: answer.type,
          items: answer.items,
          questionCategoryId: answer.questionCategoryId,
        };

    if (answer.type == 'checkbox' || answer.type == 'radio' || answer.type == 'button' || answer.type == 'location' || answer.type == 'department' || answer.type == 'dropdown') {
      q.answer = {
        id: (answer.items || []).filter(item => item.selected).map(item => item.id),
      };
    } else if (answer.type == 'textbox') {
      q.answer = { id: null, text: answer.answerText ?? '' };
    } else if (!qFromForm) {
      q.answer = false;
    }

    out.push(q);
  }
  return out;
};

const Case = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { getToken, resetToken } = useUserStore();
  const { company, companyId, questions: questionList, setCompanyId, setCompany, fetchData } = useDataStore();

  const refCaseId = useRef(window.location.hash.substring(1));
  const [caseFetchNonce, setCaseFetchNonce] = useState(0);
  const refContent = useRef(null);
  const refForm = useRef(null);
  const refNavBar = useRef(null);
  const refCaseHeader = useRef(null);
  const fileInputRef = useRef(null);
  const scrollSectionRef = useRef(null);

  const [questions, setQuestions] = useState([]);
  const [messages, setMessages] = useState([]);
  const [inputText, setInputText] = useState('');
  const [myCases, setMyCases] = useState([]);
  const [activeCase, setActiveCase] = useState({});
  const [closePopup, setClosePopup] = useState(false);
  const [closeReason, setCloseReason] = useState('');

  const [isCases, setIsCases] = useState(true);

  const updateScrollSectionHeight = () => {
    const contentTop = refContent.current.getBoundingClientRect().top;
    const formHeight = refForm.current.clientHeight;
    const caseHeaderHeight = refCaseHeader.current?.clientHeight;

    refNavBar.current.style.height = `${window.innerHeight - 145}px`;

    let newHeight = window.innerHeight - contentTop - formHeight - (caseHeaderHeight || 0) - 150;

    let ____h = refContent.current.clientHeight - (refForm.current.clientHeight + refCaseHeader.current?.clientHeight) - 130;

    if (window.innerWidth <= 991) {
      newHeight = newHeight - 180;
      ____h = ____h - 80;
    } else {
      newHeight = newHeight - 100;
    }

    setTimeout(() => {
      if (isNaN(____h)) {
        if (scrollSectionRef.current) {
          scrollSectionRef.current.style.height = `${newHeight}px`;
        }
      } else {
        if (scrollSectionRef.current) {
          scrollSectionRef.current.style.height = `${____h}px`;
        }
      }
    });
  };

  useEffect(() => {
    const caseList = myCases.map(caseItem => {
      if (caseItem.id == activeCase.id) {
        caseItem.caseUserUnreadCount = 0;
      }
      return caseItem;
    });

    setMyCases(caseList);

  }, [activeCase]);

  useEffect(() => {
    setCompanyId(companyId);
    fetchData();
  }, [companyId]);

  const getCaseListFromServer = () => {
    apiService.get('/cases', getToken()).then(res => {
      if (res.cases) {
        setMyCases(res.cases);

        if (!res.cases.length) {
          setIsCases(false);
        }
      } else {
        if (res.error) {
          resetToken();
          navigate(`/${companyId || ''}`);
        }
      }
    }).catch(err => {
      resetToken();
      navigate(`/${companyId || ''}`);
    });
  };

  //we will rewrite it to the WebSocket
  const getMessagesFromServer = () => {
    const controller = new AbortController();
    apiService.get(`/cases/${refCaseId.current}`, getToken(), controller.signal).then(res => {
      if (res.case) {
        if (messages.length != res.case?.messages.length || res.case.id != activeCase.id) {
          setMessages(res.case?.messages);
        }
      }
    }).catch(err => {
      // resetToken();
      // navigate(`/${companyId || ''}`);
      console.log('err >> ', err);
    });
  };

  useEffect(() => {
    if (!refCaseId.current) {
      return undefined;
    }

    const controller = new AbortController();
    const { signal } = controller;

    setQuestions([]);
    setMessages([]);

    apiService.get(`/cases/${refCaseId.current}`, getToken(), signal).then(res => {
      if (signal.aborted) {
        return;
      }

      if (res.error && !res.case) {
        resetToken();
        navigate(`/${companyId || ''}`);
        return;
      }

      if (!res.case) {
        return;
      }

      setMessages(res.case?.messages);
      setActiveCase(res.case);

      if (res.case.company) {
        setCompany(res.case.company);

        if (res.case.company.id) {
          setCompanyId(res.case.company.id);
        }
      }

      updateScrollSectionHeight();
    }).catch(err => {
      if (err?.name === 'AbortError' || signal.aborted) {
        return;
      }
      console.log('err 222 >> ', err);
    });

    return () => controller.abort();
  }, [caseFetchNonce]);

  useEffect(() => {
    if (activeCase?.id && refCaseId.current && activeCase.id !== refCaseId.current) {
      return;
    }
    if (!activeCase?.answers) {
      setQuestions([]);
      return;
    }
    setQuestions(buildQuestionsWithAnswers(activeCase.answers, questionList));
    updateScrollSectionHeight();
  }, [activeCase, questionList]);

  useEffect(() => {
    const intervalId = setInterval(getMessagesFromServer, 30000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (!myCases.length || activeCase.id) {
      return;
    }

    const hashId = window.location.hash.replace(/^#/, '');
    if (hashId && myCases.some(c => c.id === hashId)) {
      if (refCaseId.current !== hashId) {
        refCaseId.current = hashId;
        setCaseFetchNonce(n => n + 1);
      }
      return;
    }

    if (refCaseId.current && myCases.some(c => c.id === refCaseId.current)) {
      setCaseFetchNonce(n => n + 1);
      return;
    }

    refCaseId.current = myCases[0].id;
    navigate({ pathname, hash: myCases[0].id });
    setCaseFetchNonce(n => n + 1);
  }, [myCases]);

  useEffect(() => {
    const onHashChange = () => {
      const id = window.location.hash.replace(/^#/, '');
      if (!id || id === refCaseId.current) {
        return;
      }
      refCaseId.current = id;
      setCaseFetchNonce(n => n + 1);
    };
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  useEffect(() => {
    getCaseListFromServer();
    const intervalId = setInterval(getCaseListFromServer, 30000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    window.addEventListener('load', updateScrollSectionHeight);
    window.addEventListener('resize', updateScrollSectionHeight);

    return () => {
      window.removeEventListener('load', updateScrollSectionHeight);
      window.removeEventListener('resize', updateScrollSectionHeight);
    };
  }, []);

  const ScrollToThe = ( position ) => {
    if (position !== undefined) {
      scrollSectionRef.current.scrollTop = position || 0;
    }
  };

  useEffect(() => {
    if (scrollSectionRef.current) {
      ScrollToThe(scrollSectionRef.current.scrollHeight);
    }
  }, [messages]);

  const SendMessage = () => {
    if (inputText.trim() !== '') {
      apiService.post(`/cases/${refCaseId.current}/messages`, {text: inputText.trim()}, getToken()).then(resData => {
        if (resData && resData.message) {
          setInputText('');
          setMessages(prevMessages => [...prevMessages, resData.message]);
        }
      }).catch(errData => {
        console.log('errData >> ', errData);
      });
    }
  };

  const CloseCase = () => {
    apiService.post(`/cases/${refCaseId.current}/close`, {message: closeReason}, getToken()).then(resData => {
      setClosePopup(false);
      setActiveCase(prev => {
        prev.status = 'closed';
        return prev
      });
    }).catch(errData => {
      console.log('errData >> ', errData);
    });
  };

  const handleTextareaChange = (event) => {
    setCloseReason(event.target.value);
  };

  const uploadFile = (e) => {
    const file = e.target.files[0];

    if (file) {
      const formData = new FormData();
      formData.append('evidence', file);

      apiService.post(`/cases/${refCaseId.current}/messages`, formData, getToken(), true).then(resData => {
        if (resData && resData.message) {
          setMessages(prevMessages => [...prevMessages, resData.message]);
        }
      }).catch(errData => {
        console.log('errData >> ', errData);
      });
    }
  };

  const handleUploadFile = () => fileInputRef.current.click();

  const caseUserId = activeCase?.caseUser?.id;
  const caseMessageList = messages && messages.map((m, i) => {
    if (m.userId && caseUserId != m.userId) {
      if (m.evidence) {
        return <QuestionText message={m.text} key={`msg_${i}`} form={<Attachment title={m.fileName || t`File`} link={m.evidence} size={m.fileSizeBytes ? Math.round(m.fileSizeBytes / 1024)+' kB' : '220 kB'} />} />;
      }
      return <QuestionText message={m.text} key={`msg_${i}`} />;
    }
    if (m.evidence) {
      return <AnswerText key={`msg_${i}`} message={''} form={<Attachment title={m.fileName || t`File`} link={m.evidence} size={m.fileSizeBytes ? Math.round(m.fileSizeBytes / 1024)+' kB' : '220 kB'} color='#FFF' />} />;
    }
    return <AnswerText key={`msg_${i}`} message={m.text} />;
  });

  return (
    <CasePage>
      <div className='menu'>
        <Navbar bg="light" expand="lg">
          {company && company.logo && (<Navbar.Brand href={`/${companyId}`}><img className='logo' src={company.logo} alt='logo' /></Navbar.Brand>)}
          <h3>{t`My Cases`}</h3>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mr-auto">
              <h3>{t`My Cases`}</h3>
              <div className='navbarSection' ref={refNavBar}>
                {myCases.map(caseItem => {
                  return <Nav.Link
                    onClick={(e) => {
                      e.preventDefault();
                      refCaseId.current = caseItem.id;
                      navigate({ pathname, hash: caseItem.id });
                      setCaseFetchNonce(n => n + 1);
                    }}
                    className={refCaseId.current === caseItem.id ? 'active' : ''}
                    key={caseItem.id}
                    href={`#${caseItem.id}`}>
                      <img className='icon' src={CaseIcon} alt={`Case #${caseItem.id.substring(0, 8)}`} /> {t`Case`} {caseItem.number}
                      {caseItem.caseUserUnreadCount ? (<span className='label label-danger'>{caseItem.caseUserUnreadCount}</span>) : false}
                  </Nav.Link>
                })}
                {!myCases.length && isCases ? <span>{t`Loading...`}</span> : false}
              </div>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>
      <div className='content' ref={refContent}>
        {(!activeCase || !activeCase.status) ? (
          <>
            <div className='caseHeader' ref={refCaseHeader}></div>
            <div className='form' ref={refForm}>
              {!isCases ? <span>{t`There are no active cases at this moment.`}</span> : <span>{t`Loading...`}</span>}
            </div>
          </>
        ) : (
          <>
            {(activeCase?.id && activeCase.status) ? (
              <div className='caseHeader' ref={refCaseHeader}>
                <h1>{t`Case`} #{activeCase.number}</h1>
                <Button title={t`Scroll to the top`} className='scrollToTheTop' onClick={() => ScrollToThe(0)} />
                {activeCase && activeCase.status == 'pending' ? (<Button title={t`Close case`} className='' onClick={() => setClosePopup(true)} />) : false}
              </div>
            ) : false}
            <hr />
            <div
              className='scrollSection'
              ref={scrollSectionRef}
            >
              {(questions && questions.length) ? (<>
                  <Fieldset title={t`Case has been reported`} time={activeCase.createdAt} />
                  <Fieldset title={t`Manager has been assigned to your case`} time={activeCase.createdAt} />
                  {questions && (questions.map((q, index) => <Question dontShowResetBtn={true} key={`q_${index}`} data={q} />))}
                  {caseMessageList}
                </>) : (activeCase?.answers?.length > 0 && questionList == null && isCases) ? (
                  <span>{t`Loading...`}</span>
                ) : (activeCase?.id && activeCase.status) ? (<>
                  <Fieldset title={t`Case has been reported`} time={activeCase.createdAt} />
                  <Fieldset title={t`Manager has been assigned to your case`} time={activeCase.createdAt} />
                  {caseMessageList}
                </>) : (
                <>
                  {isCases ? <span>{t`Loading...`}</span> : false}
                </>
                )}
            </div>
            <hr />
            <div className='form' ref={refForm}>
            {(activeCase?.id && activeCase.status) ? (
              <>
                <HiddenInput
                  type="file"
                  accept=".jpg, .jpeg, .png, .pdf, .doc, .docx, .mp3, .mp4"
                  ref={fileInputRef}
                  onChange={uploadFile}
                />
                <button className='uploadFile' onClick={handleUploadFile}><img src={clipIcon} alt={t`upload`} /></button>
                <input
                  type='text'
                  name='message'
                  className='message'
                  placeholder={t`Type here`}
                  value={inputText}
                  onChange={(e) => setInputText(e.target.value)}
                />
                <Button title={t`Send`} className='sendMsg' onClick={SendMessage} />
              </>
            ) : false}
            </div>
          </>
        )}
      </div>
      {closePopup ? (
        <Popup open={true} onClose={() => setClosePopup(false)} height='50vh'>
          <h2>{t`Close case`}</h2>
          <div className='row'>
            <p>{t`Thank you for taking action to make our community a safer and more respectful place for everyone.`}</p>
            <label htmlFor="story">{t`Why are you closing this case?`}</label>
            <textarea
              onChange={handleTextareaChange}
              value={closeReason}
              className='mt-3 p-2 ml10px'
              placeholder={t`Write your message`}
              id="story"
              rows="5"></textarea>
          </div>
          <Flex>
            <Button className='mt-3' type='secondary' title={t`Cancel`} onClick={() => setClosePopup(false)} />
            <Button className='mt-3 ml10px' type='primary' title={t`Close`} onClick={CloseCase} />
          </Flex>
        </Popup>
      ) : false}
    </CasePage>
  );
};

export default Case;
